/**
 * IDG Meeting Analytics Overlay
 * Wrapper for the IDG Meeting Analytics dashboard as a sheet overlay
 */

import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import IDGMeetingAnalytics from "@/components/IDGMeetingAnalytics";
import { BarChart3 } from "lucide-react";

export default function IDGMeetingAnalyticsOverlay({ isOpen, onClose }) {
  return (
    <Sheet open={isOpen} onOpenChange={onClose}>
      <SheetContent 
        side="right" 
        className="w-[900px] sm:max-w-[900px] bg-slate-900 border-slate-700 overflow-y-auto"
      >
        <SheetHeader className="mb-4">
          <SheetTitle className="text-white flex items-center gap-2">
            <BarChart3 className="w-5 h-5 text-teal-400" />
            IDG Meeting Analytics
          </SheetTitle>
        </SheetHeader>
        <IDGMeetingAnalytics onClose={onClose} />
      </SheetContent>
    </Sheet>
  );
}
